import { render, staticRenderFns } from "./baseCost.vue?vue&type=template&id=2ad7a28f&scoped=true"
import script from "./baseCost.vue?vue&type=script&lang=js"
export * from "./baseCost.vue?vue&type=script&lang=js"
import style0 from "./baseCost.vue?vue&type=style&index=0&id=2ad7a28f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad7a28f",
  null
  
)

export default component.exports